import { Vue, Component, Mixins } from 'vue-property-decorator';
import MyCommon from './common';

@Component
export default class MyListExtends extends Mixins(MyCommon) {
  async loadDataWithSetSearchData(params: any = {}, changeRoute = true) {
    // @ts-ignore, must be with MyList
    this.searchData = { ...this.searchData, ...params };
    // @ts-ignore, must be with MyList
    return this.loadData(params, changeRoute);
  }
}
